
export default {
  props: {
    loading: Boolean,
    added: Boolean,
  },
};
